export const FETCH_HELP_DOC = 'FETCH_HELP_DOC'

export const fetchHelpDoc = (url, targetWindow) => ({
  type: FETCH_HELP_DOC,
  url,
  targetWindow
})
